var datetime=function getCurrentTime (time) {
    let date = new Date(time)
    let Y = date.getFullYear()
    let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
    let D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
    // let hours = date.getHours()
    // let minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
    // let seconds = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
    date = Y + '年' + M + '月' + D + '日 ' 
     console.log(date)  //2019-10-12 15:19:33
    return date
  }
 

 export default datetime 